import { Link, useLocation } from 'react-router-dom';
import { isArPath } from '../i18nRoutes';
import { TRIPADVISOR_RATING, TRIPADVISOR_REVIEW_COUNT } from '../data/reviewStats';

const TA_URL = 'https://www.tripadvisor.com/Attraction_Review-g293974-d25289505-Reviews-or10-Viaturkey_Tours-Istanbul.html';

export function Footer({ t }) {
  const isAr = isArPath(useLocation().pathname);
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-ta-badge">
          <a href={TA_URL} target="_blank" rel="noopener noreferrer" className="ta-trust-badge" data-testid="footer-ta-badge">
            <i className="fab fa-tripadvisor"></i>
            <span><strong>{TRIPADVISOR_RATING}/5</strong> {isAr ? 'على' : 'on'} TripAdvisor ({TRIPADVISOR_REVIEW_COUNT} {isAr ? 'تقييم' : 'reviews'})</span>
          </a>
        </div>
        <p style={{marginTop: '0.5rem'}}><Link to="/services" style={{color: '#94a3b8', textDecoration: 'none'}}>{isAr ? 'الخدمات' : 'Services'}</Link> · <Link to="/about/akin-guzel" style={{color: '#94a3b8', textDecoration: 'none'}}>{isAr ? 'عن أكين غوزيل' : 'About Akın Güzel'}</Link></p>
        <p>{t.footer.rights}</p>
        <p>{t.footer.tagline}</p>
      </div>
    </footer>
  );
}
